export default __webpack_public_path__ + "static/media/IconDesc_CrystalOscillator.256.72f7d016.png";